import type * as yup from 'yup';
import type { userSchema } from 'app/schemas/user';
import type { FeatureFlag } from 'app/utils/helpers';

export type User = yup.InferType<typeof userSchema>;

export interface CreateGuidelinesDTO {
  startingKit: boolean;
  acceptConditions: boolean;
  acceptGuidelines: boolean;
}

export interface ChangePasswordDTO {
  password: string;
  newPassword: string;
}

export interface UpdateUserDTO {
  inviteCode: string;
}

export interface CreateUserDTO {
  email: string;
  password: string;
}

export interface VerifyUserDTO {
  code: string;
  email: string;
}

export interface ForgotPasswordDTO {
  email: string;
}

export interface ResetPasswordDTO {
  code: string;
  email: string;
  password: string;
}

export interface FindAllUsersDTO {
  groupIds?: string[];
  addressIds?: string[];
  search?: string;
  sortBy?: 'distance' | 'relevance';
  canReceiveInAppContact?: boolean;
}

export interface InvitedUser {
  id: string;
  profile: { picture: string };
}

export enum UserType {
  PRO = 'pro',
  PUBLIC = 'public',
}

export type UserTypesConfig = { name: UserType; enabled: FeatureFlag[] }[];
